export type NavbarItem = {
  label: string;
  href: string;
  audience?: "anonymous" | "authenticated";
  children?: NavbarItem[];
};

export const publicItems: NavbarItem[] = [
  { label: "Strom", href: "/tarifoptimierung?categoryType=ELECTRICITY", audience: "anonymous" },
  { label: "Gas", href: "/tarifoptimierung?categoryType=GAS", audience: "anonymous" },
  {
    label: "Solar",
    href: "#",
    audience: "anonymous",
    children: [
      { label: "Balkonkraftwerk", href: "https://www.remind.me/wp-balkonkraftwerk/?showNav=true" },
      { label: "Solaranlagen", href: "https://www.remind.me/wp-solar/?showNav=true" },
    ],
  },
  { label: "Top-Deals", href: "/top-deals", audience: "anonymous" },
];

export const authenticatedItems: NavbarItem[] = [
  { label: "Mein remind.me", href: "/mein-remindme", audience: "authenticated" },
  { label: "Angebote", href: "/mein-remindme/angebote", audience: "authenticated" },
  { label: "Wechselservice", href: "/mein-remindme/wechselservices", audience: "authenticated" },
];

export const profileItems: NavbarItem[] = [
  { label: "Mein Profil", href: "/mein-remindme/profil" },
  { label: "Meine Prämien", href: "/mein-remindme/praemien" },
  { label: "Fragen und Antworten", href: "/fragen-und-antworten" },
];

export const hiddenNavigationRoutes = [
  "abschlie%C3%9Fen/",
  "wechselservice-sieger-fuer-strom-und-gas",
  "wechselservice-sieger-fuer-heizstrom",
];
